/* Smoke One storefront inventory hard guard
 * Uses exact per-variant Liquid inventory emitted by snippets/js-bridge.liquid.
 * This is a second line of defense around the custom cart flow so a shopper
 * cannot add more tracked/deny inventory than Shopify reports on the PDP.
 */
(function () {
  'use strict';

  if (window.__soInventoryGuardReady) return;
  window.__soInventoryGuardReady = true;

  var inventory = window.__SO_PRODUCT_INVENTORY__ || null;
  if (!inventory || !inventory.variants) return;

  var style = document.createElement('style');
  style.id = 'so-inventory-guard-styles';
  style.textContent = [
    'form[data-so-inventory-max="true"] button[type="submit"]{cursor:not-allowed!important;opacity:.62!important;}',
    'button[data-so-inventory-max="true"]{pointer-events:none!important;}',
    '.so-pdp-atc[data-so-inventory-max="true"]>span,.so-pdp-mobile-buy button[data-so-inventory-max="true"]>span{display:none!important;}',
    '.so-pdp-atc[data-so-inventory-max="true"]::after,.so-pdp-mobile-buy button[data-so-inventory-max="true"]::after{content:"Max available · In cart";}',
    '#CustomCartDrawer .quantity-btn[data-so-inventory-max="true"]{opacity:.35!important;cursor:not-allowed!important;pointer-events:none!important;}'
  ].join('');
  document.head.appendChild(style);

  function stockInfo(variantId) {
    var raw = inventory.variants[String(variantId)];
    if (!raw) return null;

    var managed = raw.inventory_management !== null && raw.inventory_management !== undefined && raw.inventory_management !== '';
    var denyOversell = String(raw.inventory_policy || '').toLowerCase() !== 'continue';
    var quantity = Number(raw.inventory_quantity);

    if (!managed || !denyOversell || !Number.isFinite(quantity)) return null;

    return {
      quantity: Math.max(0, quantity),
      available: raw.available !== false
    };
  }

  function variantQty(cart, variantId) {
    return (cart && cart.items || []).reduce(function (sum, item) {
      return String(item.variant_id) === String(variantId)
        ? sum + Number(item.quantity || 0)
        : sum;
    }, 0);
  }

  function isBogoCartItem(item) {
    var text = [item && item.product_title, item && item.variant_title, item && item.title]
      .filter(Boolean)
      .join(' ');
    return /\bBOGO\b/i.test(text);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not verify cart inventory.');
      return response.json();
    });
  }

  function limitMessage(info, inCart) {
    if (!info || info.quantity <= 0) return 'This item is sold out.';
    if (info.quantity === 1 && inCart >= 1) return 'Only 1 is available, and it is already in your cart.';
    if (inCart >= info.quantity) return 'Maximum available quantity is already in your cart.';
    return 'Only ' + info.quantity + ' are available.';
  }

  function getFormVariantId(form) {
    if (!form) return null;
    var field = form.querySelector('[name="id"]');
    return field && field.value ? field.value : null;
  }

  function setFormMaxState(form, maxed, message) {
    if (!form) return;
    form.dataset.soInventoryMax = maxed ? 'true' : 'false';

    form.querySelectorAll('button[type="submit"]').forEach(function (button) {
      if (maxed) {
        if (button.dataset.soInventoryMax !== 'true') {
          button.dataset.soInventoryWasDisabled = button.disabled ? 'true' : 'false';
        }
        button.dataset.soInventoryMax = 'true';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        if (message) button.title = message;
      } else if (button.dataset.soInventoryMax === 'true') {
        button.dataset.soInventoryMax = 'false';
        button.removeAttribute('aria-disabled');
        button.removeAttribute('title');
        if (button.dataset.soInventoryWasDisabled !== 'true') button.disabled = false;
        delete button.dataset.soInventoryWasDisabled;
      }
    });
  }

  function syncProductForms(cart) {
    document.querySelectorAll('form[action="/cart/add"], form[action$="/cart/add"]').forEach(function (form) {
      var variantId = getFormVariantId(form);
      var info = stockInfo(variantId);
      if (!variantId || !info) return;

      var inCart = variantQty(cart, variantId);
      var maxed = inCart >= info.quantity;
      setFormMaxState(form, maxed, maxed ? limitMessage(info, inCart) : '');
    });
  }

  function syncDrawer(cart) {
    if (!cart || !Array.isArray(cart.items)) return;

    cart.items.forEach(function (item) {
      var total = variantQty(cart, item.variant_id);

      if (isBogoCartItem(item)) {
        var escapedBogoKey = String(item.key);
        try { escapedBogoKey = CSS.escape(escapedBogoKey); } catch (e) { escapedBogoKey = escapedBogoKey.replace(/"/g, '\\"'); }
        var bogoRow = document.querySelector('.drawer-cart-item[data-key="' + escapedBogoKey + '"]');
        if (!bogoRow) return;

        var bogoControls = bogoRow.querySelectorAll('.drawer-quantity-controls .quantity-btn');
        var bogoPlus = bogoControls.length ? bogoControls[bogoControls.length - 1] : null;
        if (!bogoPlus) return;

        bogoPlus.dataset.soInventoryMax = 'false';
        bogoPlus.classList.remove('stock-plus-disabled');
        bogoPlus.disabled = total >= 2;
        bogoPlus.setAttribute('aria-disabled', total >= 2 ? 'true' : 'false');
        bogoPlus.title = total >= 2 ? 'Maximum 2 BOGO packs' : 'Add one more BOGO pack';
        return;
      }

      var info = stockInfo(item.variant_id);
      if (!info) return;

      var maxed = total >= info.quantity;
      var escapedKey = String(item.key);
      try { escapedKey = CSS.escape(escapedKey); } catch (e) { escapedKey = escapedKey.replace(/"/g, '\\"'); }
      var row = document.querySelector('.drawer-cart-item[data-key="' + escapedKey + '"]');
      if (!row) return;

      var controls = row.querySelectorAll('.drawer-quantity-controls .quantity-btn');
      var plus = controls.length ? controls[controls.length - 1] : null;
      if (!plus) return;

      if (maxed) {
        plus.dataset.soInventoryMax = 'true';
        plus.disabled = true;
        plus.setAttribute('aria-disabled', 'true');
        plus.title = limitMessage(info, total);
      } else if (plus.dataset.soInventoryMax === 'true') {
        plus.dataset.soInventoryMax = 'false';
        plus.disabled = false;
        plus.removeAttribute('aria-disabled');
        plus.removeAttribute('title');
      }
    });
  }

  function sync(cart) {
    if (!cart) return;
    syncProductForms(cart);
    syncDrawer(cart);
  }

  /* Repair any stale/invalid quantity that may already be in the cart from a
     previous storefront bug. Allocation is deterministic across duplicate lines
     of the same variant and never exceeds the Liquid inventory cap. */
  function enforceCartInventory(cart) {
    if (!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);

    var remaining = {};
    var updates = {};
    var changed = false;

    cart.items.forEach(function (item) {
      if (isBogoCartItem(item)) return;

      var info = stockInfo(item.variant_id);
      if (!info) return;

      var id = String(item.variant_id);
      if (!Object.prototype.hasOwnProperty.call(remaining, id)) {
        remaining[id] = info.quantity;
      }

      var currentQty = Math.max(0, Number(item.quantity || 0));
      var allowedQty = Math.max(0, Math.min(currentQty, remaining[id]));
      remaining[id] = Math.max(0, remaining[id] - allowedQty);

      if (allowedQty !== currentQty) {
        updates[item.key] = allowedQty;
        changed = true;
      }
    });

    if (!changed) return Promise.resolve(cart);

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not correct cart inventory.');
      return response.json();
    }).then(function (nextCart) {
      if (typeof window.updateCartDisplay === 'function') window.updateCartDisplay(nextCart);
      if (typeof window.updateCartCount === 'function') window.updateCartCount(nextCart.item_count || 0);
      return nextCart;
    });
  }

  function refreshSync() {
    return fetchCart()
      .then(enforceCartInventory)
      .then(function (cart) {
        sync(cart);
        return cart;
      })
      .catch(function () { return null; });
  }

  function wrapSafeCartAdd() {
    if (typeof window.safeCartAdd !== 'function') return false;
    if (window.safeCartAdd.__soInventoryGuardWrapped) return true;

    var original = window.safeCartAdd;

    var wrapped = function (payload) {
      payload = payload || {};
      var variantId = payload.id;
      var info = stockInfo(variantId);
      if (!variantId || !info) return original.apply(this, arguments);

      var requested = Math.max(1, Number(payload.quantity || 1));
      var args = arguments;
      var context = this;

      return fetchCart().then(function (cart) {
        var inCart = variantQty(cart, variantId);
        if (inCart + requested > info.quantity) {
          sync(cart);
          throw new Error(limitMessage(info, inCart));
        }
        return original.apply(context, args);
      });
    };

    wrapped.__soInventoryGuardWrapped = true;
    wrapped.__soInventoryGuardOriginal = original;
    window.safeCartAdd = wrapped;
    return true;
  }

  function wrapQuantityUpdate() {
    if (typeof window.updateQuantity !== 'function') return false;
    if (window.updateQuantity.__soInventoryGuardWrapped) return true;

    var original = window.updateQuantity;

    var wrapped = function (key, quantity) {
      var targetQty = Math.max(0, Number(quantity || 0));
      var args = arguments;
      var context = this;

      return fetchCart().then(function (cart) {
        var line = (cart.items || []).find(function (item) { return String(item.key) === String(key); });
        if (!line || targetQty <= Number(line.quantity || 0)) return original.apply(context, args);

        if (isBogoCartItem(line)) {
          var bogoArgs = [key, Math.min(targetQty, 2)];
          return original.apply(context, bogoArgs);
        }

        var info = stockInfo(line.variant_id);
        if (!info) return original.apply(context, args);

        var currentVariantTotal = variantQty(cart, line.variant_id);
        var targetVariantTotal = currentVariantTotal - Number(line.quantity || 0) + targetQty;
        if (targetVariantTotal > info.quantity) {
          sync(cart);
          alert(limitMessage(info, currentVariantTotal));
          return cart;
        }
        return original.apply(context, args);
      }).catch(function (error) {
        console.warn('Inventory quantity guard failed:', error);
        return null;
      });
    };

    wrapped.__soInventoryGuardWrapped = true;
    wrapped.__soInventoryGuardOriginal = original;
    window.updateQuantity = wrapped;
    window.removeItem = function (key) { return window.updateQuantity(key, 0); };
    return true;
  }

  function wrapCartFunctions() {
    var addReady = wrapSafeCartAdd();
    var qtyReady = wrapQuantityUpdate();
    return addReady && qtyReady;
  }

  /* A hard capture-level stop remains even if Alpine later toggles the disabled
     property back after its success animation. Window capture runs before the
     document-level cart listener. */
  window.addEventListener('click', function (event) {
    var button = event.target && event.target.closest
      ? event.target.closest('form[action="/cart/add"] button[type="submit"], form[action$="/cart/add"] button[type="submit"]')
      : null;
    if (!button) return;

    var form = button.form || button.closest('form');
    if (!form || form.dataset.soInventoryMax !== 'true') return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    fetchCart().then(function (cart) {
      var variantId = getFormVariantId(form);
      var info = stockInfo(variantId);
      var inCart = variantQty(cart, variantId);
      alert(limitMessage(info, inCart));
      sync(cart);
      if (typeof window.openCustomCartDrawer === 'function') window.openCustomCartDrawer(cart);
    }).catch(function () {});
  }, true);

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || form.dataset.soInventoryMax !== 'true') return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }, true);

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart) {
      enforceCartInventory(cart).then(sync).catch(function () {});
    } else {
      refreshSync();
    }
  });

  document.addEventListener('theme:product:add', function (event) {
    var detail = event.detail || {};
    if (detail.cartPromise && typeof detail.cartPromise.then === 'function') {
      detail.cartPromise
        .then(enforceCartInventory)
        .then(sync)
        .catch(function () {});
    } else {
      setTimeout(refreshSync, 0);
    }
  });

  document.addEventListener('theme:change:variant', function () {
    setTimeout(refreshSync, 0);
  });

  document.addEventListener('theme:variant:change', function () {
    setTimeout(refreshSync, 0);
  });

  if (!wrapCartFunctions()) {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (wrapCartFunctions() || tries >= 20) clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshSync, { once: true });
  } else {
    refreshSync();
  }
})();
